// Author: Fabrice Elono Piseth
//class: 1ACS

//Progress bar
function updateProgressBar() {
    const { scrollTop, scrollHeight, clientHeight } = document.documentElement;
    const scrollPercent = `${(scrollTop / (scrollHeight - clientHeight)) * 100}%`;
    document.querySelector('#progress-bar').style.setProperty('--progress', scrollPercent);

    const progressBar = document.querySelector('#progress-bar');
    if (scrollTop > 0) {
        progressBar.classList.add('show');
    } else {
        progressBar.classList.remove('show');
    }
}
//parallax scrolling
const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
        console.log(entry);
        if (entry.isIntersecting) {
            entry.target.classList.add('show');
        } else {
            entry.target.classList.remove('show');
        }
    });
});
const hiddenElements = document.querySelectorAll('.hidden');
const hiddenRight = document.querySelectorAll('.hidden-right');
const hiddenTop = document.querySelectorAll('.hidden-top');

hiddenElements.forEach((el) => observer.observe(el));
hiddenRight.forEach((el) => observer.observe(el));
hiddenTop.forEach((el) => observer.observe(el));
//progress bar
document.addEventListener('scroll', updateProgressBar);
//This scirpt helps in knowing if you are close to the end of the page with the progress bar value increasing when scrolling down
